import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getProviderVideos, addProviderVideo, updateProviderVideo, deleteProviderVideo } from "../slice/providerPanelVideoSlice";

const ProviderPanelVideo = () => {
    const dispatch = useDispatch();
    const { providerVideos } = useSelector((state) => state.providerVideos);
    const [showAddModal, setShowAddModal] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [currentVideo, setCurrentVideo] = useState(null); // for edit
    const [editVideoUrl, setEditVideoUrl] = useState("");
    const [showEditModal, setShowEditModal] = useState(false);

    const providerToken = localStorage.getItem("provider_access_token");

    useEffect(() => {
      dispatch(getProviderVideos(providerToken));
    }, [dispatch]);

    //   console.log("providerVideos", providerVideos);

    const handleAddVideosModel = () => {
      setShowAddModal(true);
    };

    const handleCloseAddVideosModal = () => {
      setShowAddModal(false);
    };

    const handleAddVideo = async () => {
      if (!videoUrl) {
        toast.error("Please enter a video URL.");
        return;
      }
      // Call your API or dispatch redux action
      const result  = await dispatch(addProviderVideo({ token: providerToken, video_url: videoUrl }));

      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Video added successfully!", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });

        setVideoUrl("");
        setShowAddModal(false);
        dispatch(getProviderVideos(providerToken));
      } else {
        toast.error("Failed to add video", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });
      }
    };

    const handleUpdateVideo = async () => {
      if (!editVideoUrl) {
        toast.error("Please enter a video URL.");
        return;
      }

      const result = await dispatch(updateProviderVideo({
        token: providerToken,
        id: currentVideo.id,
        video_url: editVideoUrl
      }));

      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Video updated successfully!", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });
        setShowEditModal(false);
        setCurrentVideo(null);
        dispatch(getProviderVideos(providerToken));
      } else {
        toast.error("Failed to update video", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });
      }
    };

    const handleDeleteVideo = async (videoId) => {
      if (!window.confirm("Are you sure you want to delete this video?")) return;
    
      const result = await dispatch(deleteProviderVideo({ token: providerToken, videoId }))
        if (result.meta.requestStatus === "fulfilled") {
          toast.success("Video deleted successfully!", {
            position: "top-right",
            autoClose: 2000,
            style: { fontSize: "0.85rem" },
          });
          dispatch(getProviderVideos(providerToken));
        } else {
          toast.error("Failed to delete video.", {
            position: "top-right",
            autoClose: 2000,
            style: { fontSize: "0.85rem" },
          });
        }
    };

    const renderVideo = (url, index) => {
      url = url.trim();

      // YouTube Shorts
      if (url.includes("youtube.com/shorts/")) {
        const videoId = url.split("/shorts/")[1];
        return (
          <div key={index}>
            <iframe
              width="360"
              height="215"
              src={`https://www.youtube.com/embed/${videoId}`}
              title={`Provider Video ${index + 1}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <br />
            {/* <small>{url}</small> */}
          </div>
        );
      }

      // YouTube Watch
      if (url.includes("youtube.com/watch?v=")) {
        const videoId = new URLSearchParams(url.split("?")[1]).get("v");
        return (
          <div key={index}>
            <iframe
              width="360"
              height="215"
              src={`https://www.youtube.com/embed/${videoId}`}
              title={`Provider Video ${index + 1}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <br />
            {/* <small>{url}</small> */}
          </div>
        );
      }

      // Direct video
      if (/\.(mp4|webm|ogg)$/i.test(url)) {
        return (
          <div key={index}>
            <video width="360" height="215" controls>
              <source src={url} type={`video/${url.split(".").pop()}`} />
              Your browser does not support the video tag.
            </video>
            <br />
            {/* <small>{url}</small> */}
          </div>
        );
      }

      // Unsupported
      return (
        <div key={index}>
          <p>Unsupported video format or URL:</p>
          <small>{url}</small>
        </div>
      );
    };

  return (
    <>
      <style>{`
        .video-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); /* Automatically adjusts based on screen size */
        gap: 20px; /* Space between video elements */
        padding: 20px;
      }

      .video-frame {
        width: 100%;
        height: 215px;
      }

      .video-card {
        position: relative; /* Ensures that the overlay buttons are positioned correctly */
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        padding: 10px;
      }

      /* Button container with absolute positioning */
      .button-container {
        position: absolute;
        top: 70px;
        right: 25px;
        display: flex;
        flex-direction: column; /* Align buttons vertically */
        gap: 10px; /* Vertical space between buttons */
      }

      .button-container button {
        padding: 5px 10px;
        font-size: 14px;
      }

      /* Media query for smaller screens */
      @media (max-width: 768px) {
        .button-container {
          position: static; /* Remove absolute positioning on small screens */
          margin-top: 10px; /* Add some space between the video and buttons */
          display: flex;
          flex-direction: row; /* Align buttons horizontally on small screens */
          gap: 10px;
        }
      }
        
      `}
    </style>
      <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat d-flex">
            My Videos
            <button className="btn btn-danger ms-auto py-2" onClick={handleAddVideosModel}>
              <i class="fa fa-user-plus me-1"></i> Add Video
            </button>
          </h4>

          <div className="video-grid">
            {Array.isArray(providerVideos) && providerVideos.length > 0 ? (
              providerVideos.map((vid, i) => (
                <div key={vid.id} className="video-card">
                  {renderVideo(vid.video_url, i)}

                  {/* Button container with absolute positioning */}
                  <div className="button-container">
                    <button
                      className="btn text-primary p-1"
                      onClick={() => {
                        setCurrentVideo(vid);
                        setEditVideoUrl(vid.video_url);
                        setShowEditModal(true);
                      }}
                    >
                      <i className="fa fa-pencil font-size-20"></i>
                    </button>
                    <button
                      className="btn btn-md text-danger me-1 p-1"
                      onClick={() => handleDeleteVideo(vid.id)}
                    >
                      <i className="fa fa-trash font-size-20"></i>
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="col">
                <p>No videos found.</p>
              </div>
            )}
          </div>
        </div>
        {showAddModal && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="font-weight-bold text-primary font-size-24 line-hight-2 montserrat d-flex">Add Video</h5>
                  <button type="button" className="btn-close" onClick={handleCloseAddVideosModal} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="videoUrl" className="form-label text-primary mb-1 font-weight-semibold required">
                        Video Url:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="videoUrl"
                        value={videoUrl}
                        onChange={(e) => setVideoUrl(e.target.value)}
                      />
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-danger font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleCloseAddVideosModal}>Close</button>
                  <button className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleAddVideo}>Add</button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showEditModal && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="font-weight-bold text-primary font-size-24 line-hight-2 montserrat d-flex">Edit Video</h5>
                  <button type="button" className="btn-close" onClick={() => setShowEditModal(false)} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="editVideoUrl" className="form-label text-primary mb-1 font-weight-semibold required">Video Url:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="editVideoUrl"
                        value={editVideoUrl}
                        onChange={(e) => setEditVideoUrl(e.target.value)}
                      />
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Close</button>
                  <button className="btn btn-primary" onClick={handleUpdateVideo}>Update</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

    </>
  );
};

export default ProviderPanelVideo;